import {
    DROPZONE_SUBMIT_ERROR,
    DROPZONE_SET_ARTICLE_LIST
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    articles: [],
    errors: {},
};

export const dropZone = (state = defaultState, action) => {
    const { type, articles } = action;
    switch (type) {
        case DROPZONE_SET_ARTICLE_LIST:
            return {
                ...state,
                articles: articles
            }
        case DROPZONE_SUBMIT_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        default:
            return state;
    }
}